/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "불러오는 중"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var koKR = Object.assign(TranslationProviderComponent, {
  translations
});

export { koKR as k };
//# sourceMappingURL=ko-KR-C_lOMnlp.js.map
